import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { NavService } from '../services/nav.service';
import { TranslatorService } from '../services/translate.service';

@Component({
  selector: 'app-plugin-acquisti',
  templateUrl: './plugin-acquisti.component.html',
  styleUrls: ['./plugin-acquisti.component.scss']
})
export class PluginAcquistiComponent implements OnInit {
  ss:any;
  user:any;
  sended: boolean = false;
  certurl: SafeResourceUrl;
  title = "Certificati";
  subTitle = "EDAC - Certificati";
  innerHeight:any;
  constructor(public navService: NavService, public translate: TranslatorService, private authService: AuthService) { }

 ngDoCheck() {

    if (this.sended == false) {
      var frame: HTMLIFrameElement = document.getElementById('PluginAcquisitiIframe') as HTMLIFrameElement;
      if (frame != null) {
        this.certurl = environment.rootPluginAcquisti; //+ this.user.sub;
        setTimeout(() => {
          frame.contentWindow?.postMessage( JSON.stringify(this.ss), '*') //this.ss);
          console.log('send message to iframe %o', this.ss, this.user);
        }, 4000);
        this.sended = true;

      }
    }

  }

  loadLabels(){
    this.translate.get('LABEL.PLUGIN_ACQUISTI').subscribe(res => {
      this.title = res;
      this.subTitle = "EDAC - " + res;
    })
  }

  ngOnInit(): void {
    this.ss = window.sessionStorage;
    this.user =  this.authService.user();
    this.loadLabels();
    this.navService.setTitle(this.title);
    this.navService.setSubTitle(this.subTitle);
    this.navService.setWikiKey('NODEF');
    let actions : any;
    actions = [
    ];
    this.navService.setActions(actions);
    this.innerHeight = (window.innerHeight - 74) + 'px';
  }

}



